import React, { useEffect, useState } from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { navbarClose } from "app/store/fuse/navbarSlice";
import { getFacebookCodeCallback, getFacebookPages, postSelectedFBPageDetails } from 'app/store/fuse/integrationSlice';
import { platformIds } from 'src/app/utils/constants';
import { selectUser } from "app/store/userSlice";
import SuccessPopUp from './SuccessPopUp';

const MetaPages = () => {
  const [metaPages, setMetaPages] = useState([]);
  // change isMetaCallbackFinished to true when callback API is success
  const [isMetaCallbackFinished, setIsMetaCallbackFinished] = useState(false);
  const [selectedPageName, setSelectedPageName] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [successSubText, setSuccessSubText] = useState('');

  const path = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { institutionGatewayDetailId } = useSelector(
    (state) => state.fuse.selectLocation
  );
  const user = useSelector(selectUser);
  const latestIntegratedPlatformID = sessionStorage.getItem('latestIntegratedPlatformID');

  useEffect(() => {
    const error = new URLSearchParams(path?.search).get("error");
    if (error) {
      navigate("/integration");
    } else {
      dispatch(navbarClose());
    }
  }, []);

  // useEffect to call the callback API
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (code) {
        if (latestIntegratedPlatformID == platformIds.FACEBOOK && institutionGatewayDetailId && user?.data?.institutionMasterId) {
          const response = await dispatch(getFacebookCodeCallback({
            url: '/meta/callback',
            code,
            gatewayDetailsId: institutionGatewayDetailId,
            platformId: latestIntegratedPlatformID,
            companyId: user?.data?.institutionMasterId,
          })).unwrap(); // Use .unwrap() to get the resolved data from Redux Toolkit

          if (response?.status == 'success') {
            // setting isMetaCallbackFinished to true when facebook callback API is success
            setIsMetaCallbackFinished(true);
          }
        }
      }
    };

    handleCallback();
  }, [dispatch, institutionGatewayDetailId, user?.data?.institutionMasterId, latestIntegratedPlatformID]);

  // useEffect to call pages when isMetaCallbackFinished is true
  useEffect(() => {
    const handlePagesAPICall = async () => {
      if (isMetaCallbackFinished) {
        // Facebook
        if (latestIntegratedPlatformID == platformIds.FACEBOOK) {
          const response = await dispatch(getFacebookPages({
            url: '/meta/pages',
            gatewayDetailsId: institutionGatewayDetailId,
            platformId: latestIntegratedPlatformID,
          })).unwrap();

          if (response?.status == 'success') {
            setMetaPages(response?.data);
          }
        }
        // add else if for instagram
      }
    };

    handlePagesAPICall();
  }, [isMetaCallbackFinished]);

  const getDropDownLabel = () => {
    if (latestIntegratedPlatformID == platformIds.FACEBOOK) {
      return ' Select Facebook Page ';
    }
    // add if for instagram
    return '';
  };

  const onPageSelected = async (selectedPage) => {
    if (selectedPage) {
      // Facebook
      if (latestIntegratedPlatformID == platformIds.FACEBOOK) {
        const response = await dispatch(postSelectedFBPageDetails({
          url: '/meta/post-details',
          pageName: selectedPage?.name,
          pageId: selectedPage?.page_id,
          pageToken: selectedPage?.page_token,
          platformId: latestIntegratedPlatformID,
          gatewayDetailsId: institutionGatewayDetailId,
        })).unwrap();

        if (response?.status == 'success') {
          setSuccessMessage('Facebook Integration has been completed successfully');
          setSuccessSubText('You have successfully integrated Facebook posts.');
        }
      }
      // add else if for instagram
    }
  };

  return (
    <>
      {successMessage && (
        <SuccessPopUp
          message={successMessage}
          open={!!successMessage}
          subText={successSubText}
        />
        )}
      <Grid
        container
        sx={{
          bgcolor: "",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            width: 500,
            bgcolor: "",
            borderRadius: 5,
            boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
            mb: 5,
            pb: 5,
          }}
        >
          <Grid container sx={{ justifyContent: "center" }}>
            <Box
              component="img"
              src="/assets/images/logo/logo-image.png"
              sx={{ width: "45%" }}
            />
          </Grid>

          <Grid container sx={{ justifyContent: "center", mb: 5 }}>
            {
              metaPages?.length > 0 && (
                <FormControl
                  sx={{
                    minWidth: 300,
                  }}
                >
                  <InputLabel id="demo-simple-select-label" sx={{ background: '#fff' }}>
                    {getDropDownLabel()}
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={selectedPageName}
                    MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }}
                  >
                    {
                      metaPages?.map((page) => (
                        <MenuItem
                          onClick={() => {
                            setSelectedPageName(page?.name);
                            onPageSelected(page);
                          }}
                          value={page?.name}
                        >
                          {page?.name}
                        </MenuItem>
                      ))
                    }
                  </Select>
                </FormControl>
              )
            }
          </Grid>
        </Box>
      </Grid>
    </>
  );
};

export default MetaPages;
